module.exports = __webpack_public_path__ + "static/img_generic_filler_v2-31844c5788961adcf6469e0355d736d0.webp";